export type PendingEmployeeInvitation = {
  token: string;
  invitedBy: string;
  organizationName: string | null;
  /** True si esta cuenta ya es dueña de un negocio (no puede aceptar como empleado). */
  isOwner: boolean;
};

export type AccountSetupState = {
  requiresOwnerOnboarding: boolean;
  ownerSetupCompletedAt: string | null;
  organizationId: string | null;
  branchCount: number;
  /** ISO timestamp when the org was closed by the owner, or null if active. */
  organizationClosedAt: string | null;
  /** Invitación de empleado pendiente y no vencida para el email del usuario. */
  pendingEmployeeInvitation: PendingEmployeeInvitation | null;
  /** Optó por esperar invite en lugar de armar negocio propio. */
  awaitingEmployeeInvitation: boolean;
};

function parsePendingEmployeeInvitation(raw: unknown): PendingEmployeeInvitation | null {
  if (raw == null || typeof raw !== 'object') return null;
  const row = raw as Record<string, unknown>;
  if (typeof row.token !== 'string' || !row.token) return null;
  if (typeof row.invited_by !== 'string') return null;
  return {
    token: row.token,
    invitedBy: row.invited_by,
    organizationName: typeof row.organization_name === 'string' ? row.organization_name : null,
    isOwner: row.is_owner === true,
  };
}

export function parseAccountSetupPayload(raw: unknown): AccountSetupState | null {
  if (raw == null || typeof raw !== 'object') return null;
  const row = raw as Record<string, unknown>;
  if (typeof row.requires_owner_onboarding !== 'boolean') return null;
  return {
    requiresOwnerOnboarding: row.requires_owner_onboarding,
    ownerSetupCompletedAt:
      typeof row.owner_setup_completed_at === 'string' ? row.owner_setup_completed_at : null,
    organizationId: typeof row.organization_id === 'string' ? row.organization_id : null,
    branchCount: typeof row.branch_count === 'number' ? row.branch_count : Number(row.branch_count ?? 0),
    organizationClosedAt:
      typeof row.organization_closed_at === 'string' ? row.organization_closed_at : null,
    pendingEmployeeInvitation: parsePendingEmployeeInvitation(row.pending_employee_invitation),
    awaitingEmployeeInvitation: row.awaiting_employee_invitation === true,
  };
}
